import SearchCampaignWizard from '@/components/google-ads/search/SearchCampaignWizard';
import { LEADS_OBJECTIVE } from './leadsObjective';

/** NEW LEADS CAMPAIGN — /google-ads/leads/create/campaign */
export default function LeadsCampaignWizard() {
  return <SearchCampaignWizard objective={LEADS_OBJECTIVE} />;
}
